var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrationSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_3830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2227 8.77735C39.5195 -2.92578 20.4805 -2.92578 8.77731 8.77735C-2.92583 20.4779 -2.92583 39.522 8.77731 51.2227C14.6277 57.0755 22.3138 59.9994 29.9999 59.9994C37.6861 59.9994 45.3697 57.0755 51.2225 51.2227C62.9257 39.522 62.9257 20.4779 51.2227 8.77735ZM46.7755 21.7635L29.2672 39.2719C28.7794 39.7597 28.1392 40.0048 27.4988 40.0048C26.8585 40.0048 26.2181 39.7597 25.7304 39.2719L15.7256 29.2672C14.7477 28.2893 14.7477 26.7085 15.7256 25.7305C16.7036 24.7526 18.2844 24.7526 19.2623 25.7305L27.4988 33.967L43.2388 18.227C44.2168 17.249 45.7976 17.249 46.7755 18.227C47.7534 19.2048 47.7534 20.7856 46.7755 21.7635Z",
    fill: "#82BA71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_3830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationSuccessful);
export default __webpack_public_path__ + "static/media/registration-successful.6aac8c2e32c4455b51afdcfa394f0061.svg";
export { ForwardRef as ReactComponent };